module.exports = __webpack_public_path__ + "static/media/close.67d0bb17.svg";